import { render, staticRenderFns } from "./LeftSider.vue?vue&type=template&id=4ea27039&scoped=true&"
import script from "./LeftSider.vue?vue&type=script&lang=js&"
export * from "./LeftSider.vue?vue&type=script&lang=js&"
import style0 from "./LeftSider.vue?vue&type=style&index=0&id=4ea27039&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea27039",
  null
  
)

export default component.exports